import { render, staticRenderFns } from "./PersonGroupPage.vue?vue&type=template&id=4f250110&"
import script from "./PersonGroupPage.vue?vue&type=script&lang=js&"
export * from "./PersonGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonGroupPage.vue?vue&type=style&index=0&id=4f250110&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports